import axios from "./index";

class AuthApi {
  static Login = (data: any) => {
    return axios.post(`${base}/login`, data);
  };

  static Register = (data: any) => {
    return axios.post(`${base}/register`, data);
  };

  static Logout = (data: any) => {
    return axios.post(`${base}/logout`, data, { headers: { Authorization: `${data.token}` } });
  };

  static ForgotPassword = (email: string) => {
    return axios.post(`${base}/forgot-password`, { email });
  };

  static ValidateResetToken = (token: string) => {
    return axios.get(`${base}/reset-password/${token}`);
  };

  static ResetPassword = (token: string, password: string) => {
    return axios.post(`${base}/reset-password/${token}`, { password });
  };
}

let base = "https://inventariosbackend.velasresorts.com/inventarios/usuarios"; // ✅ si tus rutas del backend están prefijadas con /users


export default AuthApi;
